export const SERVER = {
  name: "Bone County Roleplay",
  short: "BCRP",
  ip: "212.73.137.40:22448",
  mtaLink: "mtasa://212.73.137.40:22448",
  discord: "https://discord.gg/HGJXNNcqfh",
  forum: "/forum",
  facebook: "https://www.facebook.com/profile.php?id=61594986998792",
  tiktok: "https://www.tiktok.com/@bone.county.rp",
  site: "https://bc-rp.hu",
  support: "https://vps4you.hu/smsgw.php?r=0&service=202121",
};

export const ASSETS = {
  logo: "/assets/bcrp_big.png",
  cover: "/assets/borito.png",
  heroBg: "/assets/hatter.png",
  authBg: "/assets/2b3113-9.jpg",
  screenshot: "/assets/mta-screen_2024-01-22_19-18-55.png",
};

export const NAV = [
  { label: "Hírek", href: "#hirek" },
  { label: "Galéria", href: "#galeria" },
  { label: "Fórum", href: SERVER.forum, route: true },
  { label: "Kapcsolat", href: "#kapcsolat" },
];

export const ABOUT = {
  eyebrow: "A szerverről röviden",
  title: "Bone County Roleplay",
  text: "Szerverünk ötlete 2026 elején született. Alapját a régi BCRP-mod adja, amelyet rengeteg újdonsággal és fejlesztéssel egészítünk ki.",
  facts: [
    { label: "Megnyitás", value: "2026. december" },
    { label: "Szerver verzió", value: "V1.0" },
  ],
};

export const LINKS = {
  eyebrow: "Linkek, csatlakozás",
  items: [
    { id: "mta", label: "MTA szerver csatlakozás", href: SERVER.mtaLink, meta: SERVER.ip },
    { id: "discord", label: "Discord szerver csatlakozás", href: SERVER.discord, meta: "discord.gg/HGJXNNcqfh", external: true },
    { id: "forum", label: "Átirányítás a fórumra", href: SERVER.forum, meta: "bc-rp.hu/forum", route: true },
    { id: "ucp", label: "Játékos vezérlőpult", href: "/ucp", meta: "Karakter, vagyon és játékfiók", route: true },
    { id: "facebook", label: "Facebook oldal", href: SERVER.facebook, meta: "Bone County Roleplay", external: true },
    { id: "tiktok", label: "TikTok oldal", href: SERVER.tiktok, meta: "@bone.county.rp", external: true },
  ],
};

export const NEWS = {
  eyebrow: "Hírek, újdonságok",
  items: [
    {
      id: "hibajavitasok",
      title: "Hibajavítások",
      date: "2026. május 20.",
      text: "A szerverünkön számos hibajavítást végeztünk el, hogy a játékélmény még stabilabb és élvezetesebb legyen minden játékos számára.",
    },
    {
      id: "tippmix",
      title: "Tippmix",
      date: "2026. július 23.",
      text: "Bekerült a tippmix valódi meccsekre is, így a játékosok most már valós eseményekre is fogadhatnak a szerveren.",
    },
    {
      id: "lotto",
      title: "Bekerült a lottó",
      date: "2026. július 28.",
      text: "Bevezetésre került a lottórendszer, amely lehetőséget ad a játékosoknak, hogy különböző nyereményeket nyerjenek. Hétköznaponként szelvényt vásárolhatnak, szombatonként pedig sorsolásra kerül sor.",
    },
    {
      id: "boltrendszer",
      title: "Új bolt rendszer",
      date: "2026. szeptember 15.",
      text: "Elkészült a bolt rendszer, ami minden játékosnak esélyt ad arra, hogy boltot üzemeltessen.",
    },
     {
      id: "repont",
      title: "REpont rendszer",
      date: "2026. szeptember 23.",
      text: "Elkészült a REpont-rendszer: minden elfogyasztott ital után üres üveget kapsz, amelyet a REpont-automatánál adhatsz le.",
    },
         {
      id: "bcring",
      title: "Bone Ring",
      date: "2026. szeptember 27.",
      text: "Elkészült a Bone Ring versenypálya, ahol a játékosok különböző autóversenyeken vehetnek részt. A pálya komppal közelíthető meg.",
    },
        {
      id: "kuka",
      title: "Kuka rendszer",
      date: "2026. szeptember 29.",
      text: "Elkészült a kuka rendszer, amely lehetővé teszi a játékosok számára, hogy a játék világában elhelyezett kukákban \"kincseket\" találjanak.",
    },
          {
      id: "vape",
      title: "Vape rendszer",
      date: "2026. szeptember 29.",
      text: "Elkészült a vape rendszer, ami lehetőséget ad hogy különböző tipusú/ízű vape-eket vásárolhassanak a játékosok.",
    },
           {
      id: "buvar",
      title: "Búvárkodás",
      date: "2026. október 1.",
      text: "Bekerült a szerverre a búvárkodás lehetősége, búvárfelszerelés vásárlása után, tenger alatt lévő szemetek gyűjtése, ha szerencsével jársz értékes tárgyakat is találhatsz.",
    },
             {
      id: "billiard",
      title: "Billiárd",
      date: "2026. október 2.",
      text: "Mostantól a játékosok a szerveren biliárdozhatnak is. Ha akarod egyedül is játszhatsz, vagy barátaiddal mérheted össze tudásodat.Akár tét nélkül vagy tét mellett is játszhatsz.",
    },
               {
      id: "hasznaltauto",
      title: "Használtautó kereskedés",
      date: "2026. október 3.",
      text: "Lehetőséged adódik használtautókereskedés vásárlására, ahol a megvásárolt autóidat tovább értékesítheted.",
    },
               {
      id: "chatgui",
      title: "Chat GUI",
      date: "2026. október 8.",
      text: "Chat felület egyedi megjelenést kapott a jobb láthatóság érdekében",
    },
               {
      id: "sakk",
      title: "Sakk",
      date: "2026. október 9.",
      text: "Barátaiddal lehetőség nyílik sakkpartikra a szerveren.",
    },
               {
      id: "briefcase",
      title: "Aktatáska",
      date: "2026. október 9.",
      text: "Aktatáska jelenik meg a karaktered kezében 2.000.000$ készpénzegyenleg esetén.",
    },
               {
      id: "teljesitmeny",
      title: "Teljesítmény javítás",
      date: "2026. október 9.",
      text: "Gyorsabb betöltési idő és jobb teljesítmény a szerveren. Csatlakozástól játékba lépésig mindössze 50mp alatt történik.",
    },
               {
      id: "openpass",
      title: "Opening Pass",
      date: "2026. október 9.",
      text: "Bekerült az opening pass a szerverre, ami majd különleges jutalmakat biztosít a játékosoknak.",
    },
                  {
      id: "bonestock",
      title: "Bone County Stock Market",
      date: "2026. október 10.",
      text: "Bekerült a Bone County Stock Market a szerverre, ahol a játékosok részvényekkel kereskedhetnek és profitot szerezhetnek. A részvények árfolyama a játékosok befektetésétől függ.",
    },
                  {
      id: "ucp",
      title: "UCP",
      date: "2026. október 10.",
      text: "Bekerült az UCP az oldalra, ami lehetővé teszi a játékosok számára a fiókjuk kezelését és különleges funkciók elérését.(folyamatos fejlesztés alatt)",
    },
                  {
      id: "repontupd",
      title: "REpont update",
      date: "2026. október 10.",
      text: "Frissült a REpont rendszer a szerveren, ami új funkciókat és javításokat tartalmaz a játékosok számára. 20db üres üveg esetén zsákba rendezi, ami látható is a karakter kezében.",
    },
                {
      id: "crypto",
      title: "Crypto rendszer",
      date: "2026. október 12.",
      text: "Bevezetésre került a crypto rendszer a szerveren, saját magadnak állíthatod össze a gépeket minden hardver különböző tulajdonsággal bír, amivel a szerverteremben bányászni tudsz és megfelelő profitot szerezhetsz.",
    },
                {
      id: "kertesz",
      title: "Kertész munka",
      date: "2026. október 12.",
      text: "Bevezetésre került a kertész munka a szerveren, ahol a játékosok kertészeti munkát végezhetnek.",
    },
  ],
};

export const SUPPORT = {
  title: "Támogatás",
  text: "Amennyiben támogatni szeretnéd a szervert, kattints az alábbi gombra.",
  cta: "Támogatás",
};

export const CONTACT = {
  eyebrow: "Kérdésed van? Írj nekünk",
  title: "Kapcsolat",
  text: "Ha segítségre van szükséged, hibát találtál, vagy bármilyen kérdésed van, írj nekünk e-mailben.",
  email: "support@bc-rp.hu",
};

export const MARQUEE = [
  "Bone County Roleplay",
  "Csatlakozz hozzánk még ma",
  "Hírek, újdonságok",
  "Fórum",
  "Discord",
  "V1.0",
];

export const GALLERY = [
  { src: "/assets/gallery/bonering-versenypalya.jpg", alt: "Bone Ring versenypálya" },
  { src: "/assets/gallery/versenypalya.jpg", alt: "Versenypálya" },
  { src: "/assets/gallery/horgaszhely.jpg", alt: "Horgászhely" },
];

export const FOOTER = {
  copyright: "© 2026 BC-RP.HU - Minden jog fenntartva!",
  credit: "A weboldalt készítette sTVAN",
};
